export default __webpack_public_path__ + "media/40d00e86889844ce03bd66a66a50570341e1a62c0405113c75baddce51151ce2.svg";